module.exports = __webpack_public_path__ + "img/1_023.4bcc6c34.jpg";